import { render, staticRenderFns } from "./checklist.vue?vue&type=template&id=5a9bc733&scoped=true&"
import script from "./checklist.vue?vue&type=script&lang=js&"
export * from "./checklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9bc733",
  null
  
)

export default component.exports